import type { KycVerification } from '../api/verification'

export const onboardingActions = {
  support: { href: '/onboarding', action: 'Conferir orientação de suporte' },
  review: { href: '/onboarding', action: 'Acompanhar análise' },
  identity: {
    href: '/onboarding#verificacao-identidade',
    action: 'Concluir verificação de identidade',
  },
  profile: { href: '/onboarding#dados-cadastrais', action: 'Conferir dados cadastrais' },
  bank: { href: '/onboarding#conta-bancaria', action: 'Conferir conta bancária' },
  account: { href: '/onboarding', action: 'Conferir cadastro' },
} as const

export function getOnboardingAction(next: KycVerification['onboarding']['nextStep']) {
  const kind =
    next.owner === 'support'
      ? 'support'
      : next.owner === 'stripe' || next.code === 'wait_review'
        ? 'review'
        : next.owner === 'seller' && next.code === 'identity_document'
          ? 'identity'
          : next.owner === 'seller' && ['save_profile', 'fix_field'].includes(next.code)
            ? 'profile'
            : next.owner === 'seller' &&
                ['add_bank_account', 'fix_bank_account'].includes(next.code)
              ? 'bank'
              : 'account'
  return { kind, ...onboardingActions[kind] } as const
}
